module.exports = __webpack_public_path__ + "img/20191121102629265.877d1728.png";